<template>
  <header
    class="py-3 titan-red brow-container"
  >
    <div class="brow-header">
      <router-link to="/">
        <img
          class="brow-logo"
          alt="Titan Machinery Logo"
          src="../assets/titan-machinery-logo.png"
        />
      </router-link>
      <Auth />
    </div>
  </header>
</template>

<script>
import Auth from "@/components/Auth.vue";
export default {
  name: "Brow",
  components: {
    Auth,
  },
};
</script>

<style lang="scss" scoped>
  .brow-container{
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .brow-header{
      margin: auto;
      max-width: 1300px;
      display: flex;
      padding-inline: 126px;
      justify-content: space-between;
      align-items: center;
  }

  .brow-logo {
      width: 150px;
      height: auto;
  }

  @include media-breakpoint-down(sm) {
      .brow-header {
        padding-inline: 32px;
      }
    }
</style>